import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/tesla-second-hand-romania/")({
  head: () => routeHead("/tesla-second-hand-romania/"),
  beforeLoad: () => {
    throw redirect({ href: "/cars/tesla", statusCode: 301, replace: true });
  },
});
